import React, { useEffect, useState, useContext } from "react";
import logo from "../../assets/images/logo-img.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "@mui/material/Avatar";
import Dropdown from "react-bootstrap/Dropdown";
import { resetUser } from "../../store/reducers/user";
import { useWallet } from "@solana/wallet-adapter-react";
import { ProfileContext } from "../../components/context/ProfileContext";
import Swal from "sweetalert2";
import axios from "axios";

export default function Head() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { disconnect } = useWallet();
  const {
    userProfileImage,
    setUserProfileImage,
    adminProfileImage,
    setAdminProfileImage,
    userFirstname,
    setUserFirstname,
    userLastname,
    setUserLastname,
    adminFirstname,
    setAdminFirstname,
    adminLastname,
    setAdminLastname,
  } = useContext(ProfileContext);

  const user = useSelector((state) => state.userStore.user);
  const role = user.role;
  const token = user.auth;
  const profileImage = role === "admin" ? adminProfileImage : userProfileImage;
  const firstName = role === "admin" ? adminFirstname : userFirstname;
  const lastName = role === "admin" ? adminLastname : userLastname;

  const [active, setActive] = useState('');
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handelWhitepaperOpen = () => {
    // window.open(pdfFile, "_blank");
    window.open("/lfcoin_whitepaper.pdf", "_blank");
  };

  // const handleOpenNewTab = (event) => {
  //   event.preventDefault();
  //   window.open("/login", "_blank");
  // };

  // const handleOpenNewTabSignUp = (event) => {
  //   event.preventDefault();
  //   window.open("/sign-up", "_blank");
  // };

  const scrollToContractAddress = (targetElementId) => {
    setActive('Contract Address');
    const element = document.getElementById(targetElementId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const toggleNav = () => {
    setIsNavOpen((prevState) => !prevState);
  };

  useEffect(() => {
    if (token) {
      setIsLoggedIn(true);
      const endpoint =
        role === "admin" ? "/admin/getAdminProfile" : "/users/getUserProfile";

      axios
        .get(`${process.env.REACT_APP_API_ENDPOINT_URL}${endpoint}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (response.data.status === 200) {
            const userData = response.data.data;
            if (role === "admin") {
              setAdminFirstname(capitalizeFirstLetter(userData.firstName));
              setAdminLastname(capitalizeFirstLetter(userData.lastName));
            } else {
              setUserFirstname(capitalizeFirstLetter(userData.firstName));
              setUserLastname(capitalizeFirstLetter(userData.lastName));
            }

            if (
              userData.profileImage &&
              typeof userData.profileImage === "string" &&
              userData.profileImage.trim() !== ""
            ) {
              try {
                const decodedData = Buffer.from(
                  userData.profileImage.replace(/^data:.*,/, ""),
                  "base64"
                );

                const uint8Array = new Uint8Array(decodedData.length);
                for (let i = 0; i < decodedData.length; i++) {
                  uint8Array[i] = decodedData[i];
                }

                const blob = new Blob([uint8Array]);
                const imgSrc = URL.createObjectURL(blob);

                if (role === "admin") {
                  setAdminProfileImage(imgSrc);
                } else {
                  setUserProfileImage(imgSrc);
                }
              } catch (err) {
                console.error("Failed to decode base64 image:", err);
              }
            }
          }
          else if (response.data.status === 401) {
            dispatch(resetUser());
            setIsLoggedIn(false);
            Swal.fire({
              title: "Session Expired!",
              text: "Your session has expired. Please log in again.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }

          else {
            Swal.fire({
              title: "Error!",
              text: `${response.data.message}`,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch((err) => {
          console.error("API call error:", err);
          Swal.fire({
            title: "Error!",
            text: "Something Went Wrong!",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  }, [token, user.role]);

  useEffect(() => {
    const path = location.pathname;
    if (path === '/community') {
      setActive('Community');
    } else if (path === '/') {
      setActive('Home');
    }

    else if (path === '/events') {
      setActive('Events');
    }

    else if (path === '/aboutUs') {
      setActive('More About');
    } else if (path === '/privacy-and-Policy') {
      setActive('More Privacy');
    } else if (path === '/terms-and-conditions') {
      setActive('More Term');
    } else if (path === '/frequently-asked-questions') {
      setActive('More Frequently');
    }
  }, [location]);

  const handleDashBoardRoute = () => {
    if (role === "admin") {
      navigate("/admin-dashboard");
    } else {
      navigate("/user-dashboard");
    }
  };

  const stringAvatar = () => {
    const firstNameInitial = firstName ? firstName[0].toUpperCase() : "";
    const lastNameInitial = lastName ? lastName[0].toUpperCase() : "";
    return {
      children: `${firstNameInitial}${lastNameInitial}`,
    };
  };

  const capitalizeFirstLetter = (string) => {
    return string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : "";
  };

  const logout = () => {
    dispatch(resetUser());
    disconnect();
    setIsLoggedIn(false);
    navigate("/");
  };

  const handleClick = () => {
    window.open('http://shop.lfcoin.io/', '_blank');
  }
  return (
    <div className="top-header-section container">
      <header className="home-header">
        <nav className="cstm-navigation container">
          <NavLink exact="true" to="/" 
          // onClick={toggleNav}
          >
            <img src={logo} alt="logo" className="main-logo-img" />
          </NavLink>
          <ul className={`cstm-navigation ${isNavOpen ? "main" : ""}`}>
            <li className="navlink head-tab">
              <Link to="/" className={`nav-link mid-header-nav  ${active === 'Home' ? 'active' : ''}`}
                // onClick={(e) => scrollToContractAddress("contract-address")}
                onClick={() => setActive('Home')}
              >
                Home
              </Link>
            </li>
            <li className="navlink head-tab">
              <Link to="/community" className={`nav-link mid-header-nav ${active === 'Community' ? 'active' : ''}`} onClick={() => setActive('Community')}>Community</Link>
            </li>

            <li className="mid-header-nav">
              <a className="nav-link mid-header-nav" onClick={handleClick}>
                <span>Shop</span>
              </a>
            </li>
            <li className="mid-header-nav">
              <Link to="/events"
                className={`nav-link mid-header-nav ${active === 'Events' ? 'active' : ''}`} onClick={() => setActive('Events')}>Events
              </Link>
            </li>
            <li className="mid-header-nav">
              <a className="nav-link mid-header-nav " href="javascript:void(0);" onClick={handelWhitepaperOpen}>
                <span>LFCoin Whitepaper</span>
              </a>
            </li>

            <li className="main-more-class head-tab">
              <a className={`nav-link mid-header-nav more ${['More About', 'More Privacy', 'More Term', 'More Frequently'].includes(active) ? 'active' : ''}`}>
                More
                <svg width="15px" height="15px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M2.55806 6.29544C2.46043 6.19781 2.46043 6.03952 2.55806 5.94189L3.44195 5.058C3.53958 4.96037 3.69787 4.96037 3.7955 5.058L8.00001 9.26251L12.2045 5.058C12.3021 4.96037 12.4604 4.96037 12.5581 5.058L13.4419 5.94189C13.5396 6.03952 13.5396 6.19781 13.4419 6.29544L8.17678 11.5606C8.07915 11.6582 7.92086 11.6582 7.82323 11.5606L2.55806 6.29544Z" fill="currentColor"></path>
                </svg>
              </a>
              <ul className="dropdown last-drop">
                <li>
                  <Link className={`more-link  ${active === 'More About' ? 'active' : ''}`} onClick={() => setActive('More About')} to="/aboutUs">About Us</Link>
                </li>
                <li>
                  <Link className={`more-link ${active === 'More Privacy' ? 'active' : ''}`} onClick={() => setActive('More Privacy')} to="/privacy-and-Policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link className={`more-link ${active === 'More Term' ? 'active' : ''}`} onClick={() => setActive('More Term')} to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link className={`more-link ${active === 'More Frequently' ? 'active' : ''}`} onClick={() => setActive('More Frequently')} to="/frequently-asked-questions">FAQs</Link>
                </li>
              </ul>
            </li>

          </ul>
          {user && isLoggedIn ? (
            
            <div className="navbar-profile">
              
              <div className="profile-dropdown profile">
                <Dropdown>
                  <Dropdown.Toggle variant="" id="dropdown-basic">
                    <h6>
                      {`${capitalizeFirstLetter(firstName)} ${capitalizeFirstLetter(lastName)}`}
                    </h6>
                    {profileImage ? (
                      <img
                        src={profileImage}
                        alt="Profile"
                        className="profile-image-top"
                      />
                    ) : (
                      <Avatar alt="User" {...stringAvatar()} />
                    )}
                     
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={handleDashBoardRoute}>
                      <i className="fa fa-dashboard"></i> Dashboard
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => navigate("/profile")}>
                      <i className="fa fa-user"></i> Profile
                    </Dropdown.Item>
                    <Dropdown.Item onClick={logout}>
                      <i className="fa fa-sign-out"></i> Log Out
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className={`main-icon ${isNavOpen ? "cross" : ""}`}>
                <i className="fa fa-bars hamburger-icon" onClick={toggleNav} aria-hidden="true"></i>
                <i className="fa fa-times" onClick={toggleNav} aria-hidden="true"></i>
              </div>
            </div>
          ) : (
            <div className="login-btn-section">
              <Link to="/community" className={`login_btn community-btn nav-link mid-header-nav ${active === 'Community' ? 'active' : ''}`} onClick={() => setActive('Community')}>
                Community
              </Link>
              
              {/* <Link className="login_btn community-btn" onClick={handleClick}>
                Shop
              </Link>

              <Link to="/events"
                className="login_btn community-btn">Events
              </Link> */}
            
              {/* <Link to="/login" className="login_btn">
                Login
              </Link>
              <Link to="/sign-up" className="login_btn">
                Sign Up
              </Link> */}
              <div className={`main-icon ${isNavOpen ? "cross" : ""}`}>
                <i className="fa fa-bars hamburger-icon" onClick={toggleNav} aria-hidden="true"></i>
                <i className="fa fa-times" onClick={toggleNav} aria-hidden="true"></i>
              </div>
            </div>
          )}
        </nav>
      </header>
    </div>
  );
}
